import moment from 'moment';

export const localeTimeParser = (time) => {
  if (time) return moment(time).format('HH:mm');
  else return '';
};

const destinationTimesParser = (operationalTimes) => {
  const {
    scheduledGateArrival,
    actualGateArrival,
    estimatedGateArrival,
    scheduledGateDeparture,
    actualGateDeparture,
    estimatedGateDeparture,
    takeoff,
    landing,
  } = operationalTimes;

  const departure = {
    estimated: localeTimeParser(estimatedGateDeparture?.dateLocal),
    scheduled: localeTimeParser(scheduledGateDeparture?.dateLocal),
    takeoff: localeTimeParser(takeoff?.dateLocal),
    actual: localeTimeParser(actualGateDeparture?.dateLocal),
  };

  const arrival = {
    estimated: localeTimeParser(estimatedGateArrival?.dateLocal),
    scheduled: localeTimeParser(scheduledGateArrival?.dateLocal),
    landing: localeTimeParser(landing?.dateLocal),
    actual: localeTimeParser(actualGateArrival?.dateLocal),
  };

  return {
    departure,
    arrival,
  };
};

export default destinationTimesParser;
